import { $, _, Backbone, Radio, moment } from "../../../vendor";
import InboomaBaseView from "../InboomaBaseView";
import { Backform, Notification, Biscuit } from "../../utils";

import OffCanvasAppointmentsFormTpl from "../../templates/appointments/OffCanvasAppointmentsFormTpl.html";

import OffCanvasBehavior from "../../behaviors/Behavior.OffCanvas";

export default InboomaBaseView.extend({
  template: OffCanvasAppointmentsFormTpl,
  el: "#inb-off-canvas",
  parentView: "appointments",

  behaviors: [
    {
      behaviorClass: OffCanvasBehavior,
      beforeSave: (model, view) => {
        view._appointments = model.get("appointments");
        delete model.attributes.appointments;

        model.set("client_id", Number(Biscuit.get("user.client_id")));
        model.set("valid_from", model.get("start"));
        delete model.attributes.is_recurring;
        view.isNew = model.get("id") == "";
      },
      afterSaveSuccess: (model, view, response) => {
        // @todo Repair to avoid Backbone.history
        //model = new Event(response.data);
        model.set("id", response.data.id);
        model.set("appointments", view._appointments);
        view.collection.add(model); // .set( ,{ add:true, merge:true, remove:false });

        new Notification({
          message: view.t(
            view.isNew ? "saved_${a}" : "updated_${a}",
            { a: view.t("appointment") },
            "capital",
          ),
          duration: 5000,
          type: "success",
          closeable: true,
          icon: "fi fi-calendar",
        });

        view.parentView += "/" + view.options.calendar.get("id") + "?forceRefresh=true";
        Backbone.history.navigate(view.parentView, { trigger: true });
      },
      afterSaveError: (model) => {
        new Notification({
          message: view.t("request_error"),
          duration: 5000,
          type: "warning",
          closeable: true,
          icon: "fi fi-x",
        });
      },
    },
  ],

  templateContext() {
    return {
      created_printable: moment(this.model.get("created")),
      modified_printable: moment(this.model.get("modified")),
    };
  },

  initialize() {
    $(".dropdown-pane.is-open").trigger("close");

    const that = this;

    this.contingents = Radio.channel("contingents").request("get:data");

    let contingentSelectable = false;

    this._contingentsSelectInput = [];

    _.each(this.contingents.models, (contingent, key) => {
      if (contingent.get("resourcetype_id") === 4) {
        that._contingentsSelectInput.push({
          label:
            contingent.get("name") +
            " (" +
            that.t("max_${a}_pers", { a: contingent.get("number_active") }) +
            ")",
          value: contingent.get("id"),
        });

        contingentSelectable = true;
      }
    });

    if (!contingentSelectable) {
      if (confirm(this.t("appointments_error_no_contingent"))) {
        Backbone.history.navigate("contingents/add", { trigger: true });
      } else {
        Backbone.history.navigate("appointments", { trigger: true });
        this.canvas.close();
      }
    } else {
      this.render();
    }
  },

  onRender() {
    console.log("edited event - check that checkboxes are set properly", this.model.toJSON());

    if (this.model.get("id") == "") {
      //this.model.set('contingent_id', this.contingents.models[0].get('id'));
      this.model.set("is_recurring", false);
    } else {
      if (this.model.get("rrule") != "" && !_.isNull(this.model.get("rrule"))) {
        this.model.set("is_recurring", true);
      }
    }

    let that = this,
      fields = [
        /*{
          name : "contingent_id",
          label : that.t('contingent',null,'capital'),
          required : true,
          control : "selector",
          options : that._contingentsSelectInput,
          size : {
            "small" : "5"
          }
        },*/
        {
          name: "calendar_id",
          label: that.t("calendar", null, "capital"),
          control: "select",
          disabled: true,
          options: [
            {
              label: that.options.calendar.get("title"),
              value: "bla",
            },
          ],
          size: {
            small: "4",
          },
        },
        {
          name: "title",
          label: that.t("event_title", null, "capital"),
          control: "input",
          required: true,
          size: {
            small: "8",
          },
        },
        {
          name: "start",
          label: that.t("start", null, "capital"),
          control: "datetimepicker",
          required: true,
          minDate: this.model.get("start") == "" ? new Date() : null,
          maxDate: moment().add(2, "years").toDate(),
          size: {
            large: "6",
            small: "12",
          },
          triggerPicker: "end",
          onSelectCallback: (dateMoment, apiDate) => {
            that.model.unsetWeekdays();

            that.$el.find(".select-weekday input").prop("checked", false).prop("disabled", false);

            const weekday = dateMoment.weekday() + 1;

            that.$el
              .find(`input[name="day_of_week_${weekday}"]`)
              .trigger("click")
              .attr("disabled", "disabled");
          },
        },
        {
          name: "end",
          label: that.t("end", null, "capital"),
          control: "datetimepicker",
          required: true,
          minDate: this.model.get("start") == "" ? new Date() : null,
          maxDate: moment().add(2, "years").toDate(),
          size: {
            large: "6",
            small: "12",
          },
        },
        {
          name: "is_recurring",
          label: "",
          control: "radio",
          extraTopClasses: ["radio-float-left"],
          options: [
            { label: that.t("single_appointment", null, "capital"), value: false },
            { label: that.t("recurring_appointment", null, "capital"), value: true },
          ],
        },
        {
          control: "spacer",
          extraTopClasses: ["depends-on-recurring"],
        },
        {
          name: "separation_count",
          label: that.t("repeat_every_after", null, "capital") + "...",
          control: Backform.InputControl.extend({
            initialize() {
              Backform.InputControl.prototype.initialize.apply(this, arguments);
              this.listenTo(this.model, "change:recurring_type", this.render);
            },
          }),
          type: "number",
          extraAttributes: (_model) => {
            switch (_model.get("recurring_type")) {
              default:
              case "weekly":
                return ['min="1"', 'max="4"'];
                break;
              case "monthly":
                return ['min="1"', 'max="12"'];
                break;
              case "yearly":
                return ['min="1"', 'max="2"'];
                break;
            }
            return [' max="100" '];
          },
          extraTopClasses: ["label-float-left depends-on-recurring"],
          size: {
            small: "5",
          },
        },
        {
          name: "rrule",
          label: " ",
          control: "select",
          extraTopClasses: ["depends-on-recurring"],
          options: [
            { label: that.t("week(s)"), value: "weekly" },
            { label: that.t("month(s)"), value: "monthly" },
            { label: that.t("year(s)"), value: "yearly" },
          ],
          size: {
            small: "5",
          },
        },
        {
          name: "day_of_week_1",
          label: that.t("monday"),
          control: "checkbox",
          showAsToggle: false,
          prefixLabel: "..." + that.t("day_on"),
          extraTopClasses: ["select-weekday checkbox-float-left depends-on-recurring"],
        },
        {
          name: "day_of_week_2",
          label: that.t("tuesday"),
          control: "checkbox",
          value: "1",
          showAsToggle: false,
          prefixLabel: "<br />",
          extraTopClasses: ["select-weekday checkbox-float-left depends-on-recurring"],
        },
        {
          name: "day_of_week_3",
          value: "1",
          label: that.t("wednesday"),
          control: "checkbox",
          showAsToggle: false,
          prefixLabel: "<br />",
          extraTopClasses: ["select-weekday checkbox-float-left depends-on-recurring"],
        },
        {
          name: "day_of_week_4",
          label: that.t("thursday"),
          control: "checkbox",
          showAsToggle: false,
          prefixLabel: "<br />",
          extraTopClasses: ["select-weekday checkbox-float-left depends-on-recurring"],
        },
        {
          name: "day_of_week_5",
          label: that.t("friday"),
          control: "checkbox",
          showAsToggle: false,
          extraTopClasses: ["select-weekday checkbox-float-left depends-on-recurring"],
        },
        {
          name: "day_of_week_6",
          label: that.t("saturday"),
          control: "checkbox",
          showAsToggle: false,
          extraTopClasses: ["select-weekday checkbox-float-left depends-on-recurring"],
        },
        {
          name: "day_of_week_7",
          label: that.t("sunday"),
          control: "checkbox",
          showAsToggle: false,
          extraTopClasses: ["select-weekday checkbox-float-left depends-on-recurring"],
        },
        {
          name: "valid_to",
          label: "..." + that.t("till"),
          placeholder: that.t("optional", null, "capital"),
          minDate: new Date(),
          extraTopClasses: ["depends-on-recurring"],
          size: {
            small: "5",
          },
          control: Backform.DatepickerControl.extend({
            initialize() {
              Backform.DatepickerControl.prototype.initialize.apply(this, arguments);

              this.listenTo(this.model, "all", (a, b) => {
                // When 'end' changes to a date later than 'valid_to',
                // change 'valid_to' to that value
                if ((a === "backform:change:date" && b === "end") || a === "change:end") {
                  const end = moment(this.model.get("end")),
                    valid_to = moment(this.model.get("valid_to"));

                  if (end.isAfter(valid_to)) {
                    this.model.set("valid_to", end.format("YYYY-MM-DD 23:59:59"));
                    this.render();
                  }
                }
              });
            },
          }),
        },
      ];

    if (this.model.get("id") != "") {
      fields.push(
        {
          control: "spacer",
        },
        {
          name: "remove-event",
          control: "uneditable-input",
          label: that.t("remove"),
          extraTopClasses: ["fake-link remove-event small-12 text-right"],
        },
      );
    }
    // @TODO start - end fields be like view-source:file:///var/www/html/inbooma/node_modules/pikaday/examples/date-range.html

    this.form = new Backform.Form({
      el: that.$el.find("form"),
      model: that.model,
      fields,
      events: {
        "click .remove-event": (ev) => {
          if (confirm(this.t("really_remove"))) {
            that.model.destroy({
              success: (model, response) => {
                new Notification({
                  message: that.t("removed_${a}", { a: that.t("appointment") }),
                  duration: 5000,
                  type: "success",
                  closeable: true,
                  icon: "fi fi-check",
                });

                that.canvas.close();
                Backbone.history.navigate(
                  "appointments/" + that.options.calendar.get("id") + "?forceRefresh=true",
                  { trigger: true },
                );
              },
              error: () => {
                new Notification({
                  message: that.t("request_error"),
                  duration: 5000,
                  type: "warning",
                  closeable: true,
                  icon: "fi fi-x",
                });

                that.canvas.close();
                Backbone.history.navigate("appointments/" + that.options.calendar.get("id"), {
                  trigger: true,
                });
              },
            });
          }
        },
        "change .contingent_id": (ev) => {
          // check if there are already periods for that
          // contingent and response to ui
        },
        "change .is_recurring input": (ev) => {
          if (ev.currentTarget.value == "true" || ev.currentTarget.value.indexOf("true") >= 1) {
            that.$el.addClass("recurring-on");
            if (that.model.get("rrule") == "" || that.model.get("rrule") === null) {
              that.model.set("rrule", "weekly");
              that.model.set("separation_count", 1);
            }
          } else {
            that.model.set("rrule", null);
            that.model.set("separation_count", "");
            that.$el.removeClass("recurring-on");
          }
        },
      },
    }).render();

    if (this.model.get("is_recurring")) {
      this.$el.addClass("recurring-on");
    }

    if (this.model.get("id") !== "") {
      const weekday = moment(this.model.get("start")).weekday() + 1;

      this.$el.find(`input[name="day_of_week_${weekday}"]`).attr("disabled", "disabled");
    }
  },
});
